import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Icon - Cross",
		transform: "translate(-42 -1412)",
		children: /* @__PURE__ */ _jsxs("g", {
			"data-name": "Group 4396",
			children: [/* @__PURE__ */ _jsxs("g", {
				"data-name": "Ellipse 765",
				transform: "translate(42 1412)",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				children: [/* @__PURE__ */ _jsx("circle", {
					cx: 10,
					cy: 10,
					r: 10,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("circle", {
					cx: 10,
					cy: 10,
					r: 9.25,
					fill: "none"
				})]
			}), /* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 4395",
				transform: "translate(-1.313 0.187)",
				children: [/* @__PURE__ */ _jsx("g", {
					"data-name": "Interface-Essential / Navigate / navigation-down-circle",
					transform: "translate(53.126 1422) rotate(90)",
					children: /* @__PURE__ */ _jsx("g", {
						"data-name": "Group 742",
						children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
							"data-name": "Shape 3469",
							d: "M2.626,2.626-3-3",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: 1.5
						}) })
					})
				}), /* @__PURE__ */ _jsx("g", {
					"data-name": "Interface-Essential / Navigate / navigation-down-circle",
					transform: "translate(53.5 1422)",
					children: /* @__PURE__ */ _jsx("g", {
						"data-name": "Group 742",
						children: /* @__PURE__ */ _jsx("g", {
							"data-name": "navigation-down-circle",
							children: /* @__PURE__ */ _jsx("path", {
								"data-name": "Shape 3469",
								d: "M2.626,2.626-3-3",
								fill: "none",
								stroke: "currentColor",
								strokeWidth: 1.5
							})
						})
					})
				})]
			})]
		})
	})
});
export { SvgCrossIcon as ReactComponent };
